import { createSelector } from 'reselect';
import { IDcfVessel } from './dcfTypes';
import { selectSubscribedMsiVessels } from '../../user-management/appSelectors';
import { selectSelectionData } from '../search/searchSelectors';
import { RootState } from '../../core/store';

export const selectDcfValueData = createSelector([(state: RootState) => state.dcfSlice], (valueSlice) => valueSlice.dcfValueState);

export const dcfVesselListSelector = createSelector(
    [selectSubscribedMsiVessels, selectSelectionData],
    (subscribedMsiVessels, selectionData) => {
        const selectedImoNumbers = new Set(selectionData.selectedVesselsList.map(v => v.imoNumber));
        return subscribedMsiVessels.filter(v => selectedImoNumbers.has(v.imoNumber)).map(v => (
            {
                imoNumber: v.imoNumber,
                name: v.vesselName,
                sectorName: v.sectorName,
                size: v.size,
                sizeUnit: v.sizeUnit,
                age: v.age,
                yearOfDelivery: v.yearOfDelivery,
                owner: v.owner,
                gearTankCargoContainment: v.gear || v.tank || v.cargoContainment,
                fuelSystem: v.sectorCode === 'LNG' ? v.propulsionSystem : v.fuelSystem ? v.fuelSystem : 'Conventional',
            })) as IDcfVessel[];
    }
);

